var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8V7.5M3 7.5V20.5H18C18 20.5 18 14.5 18 12.5M3 7.5V7V6.5H12",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V10",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5H21.5",
    stroke: "#0078BB",
    strokeWidth: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.621 10.574H9.025L11.707 14.885H11.725V10.574H13.048V17H11.635L8.962 12.698H8.944V17H7.621V10.574Z",
    fill: "#0078BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicN1);
export default __webpack_public_path__ + "static/media/Clinic-N1.24bf1152f09641125d2e8317c37686d4.svg";
export { ForwardRef as ReactComponent };